export default "__VITE_ASSET__CGicFMBS__"